module.exports = __webpack_public_path__ + "static/media/play-icon.a3ca67b3.svg";